import angular from 'angular';

angular.module('cloudX').directive('clearImageOnError', function() {
  return {
    link: function(scope, element, attrs) {
      element.bind('error', function() {
        element.remove();
      });
    },
  };
});
